import styled from "@emotion/styled";
import { Box } from "@otrium/core";

export const ImageWrapper = styled(Box)`
  .desktop {
    display: none;
    aspect-ratio: 1440/ 472;
  }
  .mobile {
    display: block;
    aspect-ratio: 360/ 180;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    .desktop {
      display: block;
    }
    .mobile {
      display: none;
    }
  }

  img {
    width: 100%;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.tone.black};
  text-align: center;
  font-family: "Charis SIL";
  font-size: ${({ theme }) => theme.fontSizes.fontSize48};
  font-weight: ${({ theme }) => theme.fontWeights.heading};
  line-height: ${({ theme }) => theme.space.space64};
  padding-top: ${({ theme }) => theme.space.space48};
  padding-bottom: ${({ theme }) => theme.space.space32};

  @media (max-width: 640px) {
    font-size: ${({ theme }) => theme.fontSizes.fontSize32};
    line-height: ${({ theme }) => theme.text.body.highlight.lineHeight[0]};
    padding-top: ${({ theme }) => theme.space.space32};
    padding-bottom: ${({ theme }) => theme.space.space32};
    padding-left: ${({ theme }) => theme.space.space16};
    padding-right: ${({ theme }) => theme.space.space16};
  }
`;

export const EthicalLinks = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.space.space32};
  padding-top: ${({ theme }) => theme.space.space48};
  padding-bottom: ${({ theme }) => theme.space.space48};
  padding-left: ${({ theme }) => theme.space.space16};
  padding-right: ${({ theme }) => theme.space.space16};

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    padding-top: ${({ theme }) => theme.space.space64};
    padding-bottom: ${({ theme }) => theme.space.space64};
    padding-left: ${({ theme }) => theme.space.space48};
    padding-right: ${({ theme }) => theme.space.space48};
    gap: ${({ theme }) => theme.space.space24};
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    padding: ${({ theme }) => theme.space.space96};
    margin-left: ${({ theme }) => theme.space.space16};
    margin-right: ${({ theme }) => theme.space.space16};
    gap: ${({ theme }) => theme.space.space24};
  }
  .section-title {
    color: ${({ theme }) => theme.colors.tone.black};
    font-family: "Charis SIL";
    font-size: ${({ theme }) => theme.fontSizes.fontSize24};
    font-weight: ${({ theme }) => theme.fontWeights.heading};
    line-height: ${({ theme }) => theme.space.space32};
  }

  li {
    list-style-type: none;
    margin-top: ${({ theme }) => theme.space.space16};
    font-size: ${({ theme }) => theme.space.space16};
    font-weight: ${({ theme }) => theme.text.body.source.semibold16.fontWeight};
    line-height: ${({ theme }) => theme.space.space24};
    a {
      color: ${({ theme }) => theme.colors.tone.anthracite};
    }
  }
`;
